import { HTMLElement, parse } from 'node-html-parser';
import { fetchPage } from '../fetchers/index.js';
import { getTicketParams, resolveDate } from '../helpers/global.helper.js';
import {
  getCinema,
  getDay,
  getHall,
  getHour,
  getId,
  getPrice,
  getRunning,
  getTags,
  getTitle
} from '../helpers/program.helper.js';
import type {
  KinoklubCinemaChoices,
  KinoklubLanguage,
  KinoklubProgram,
  KinoklubProgramOptions
} from '../interfaces/global.js';
import { programUrl, ticketsRedirectUrl } from '../vars.js';

export class ProgramScraper {
  public async program(
    lang: KinoklubLanguage,
    cinemas?: Array<KinoklubCinemaChoices | number>,
    options: KinoklubProgramOptions = {}
  ): Promise<KinoklubProgram[]> {
    const url = programUrl(lang, cinemas, options);
    const response = await fetchPage(url);

    const html = parse(response);

    const programListNodes = html.querySelectorAll('.program__info-row');

    // return this.buildProgram(programListNodes.splice(10, 30));
    return this.buildProgram(programListNodes);
  }

  private buildProgram(moviesNode: HTMLElement[]): KinoklubProgram[] {
    return moviesNode.map((m) => {
      const hour = getHour(m);
      const day = getDay(m);

      const ticketParams = getTicketParams(m);
      const queryParams = new URLSearchParams(ticketParams).toString();

      return {
        id: getId(m),
        date: resolveDate(day, hour),
        title: getTitle(m),
        price: getPrice(m),
        hall: getHall(m),
        ticketUrl: queryParams ? ticketsRedirectUrl + '?' + queryParams : null,
        cinema: getCinema(m),
        tags: getTags(m),
        hour: getHour(m),
        isRunning: getRunning(m)
      } as KinoklubProgram;
    });
  }
}
